var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useEffect } from 'react';
import { Button, Dialog, Text, Box, Flex, FilterChip, ChatMessage } from 'pcln-design-system';
import { localCache } from '../localMessagsCache';
import { amenitiesMap } from './HotelFilterComponent';
import { TravelBotLogoImage } from '../TravelBotLogoImage';
export var SelectedFiltersOptions = function (props) {
    var _a;
    var _b = React.useState(false), isOpen = _b[0], setIsOpen = _b[1];
    var _c = React.useState({}), selectedAmenities = _c[0], setSelectedAmenities = _c[1];
    var amenities = ((_a = props === null || props === void 0 ? void 0 : props.args) === null || _a === void 0 ? void 0 : _a.amenities) || '';
    useEffect(function () {
        var prevSelectedAmenities = amenities === null || amenities === void 0 ? void 0 : amenities.split(',').reduce(function (res, key) {
            res[key] = true;
            return res;
        }, {});
        setSelectedAmenities(prevSelectedAmenities);
    }, amenities);
    var setChatMessages = props.setChatMessages, submitMessages = props.submitMessages;
    var onFilterClick = function () {
        setIsOpen(true);
    };
    return (React.createElement(Flex, { p: 2 },
        amenities && (React.createElement(Button, { variation: 'link', onClick: onFilterClick, mr: 3 }, "You can manage your filter options here.")),
        React.createElement(Dialog, { showCloseButton: true, scrimDismiss: false, open: isOpen, size: 'md', onOpenChange: function (isOpen) {
                if (!isOpen) {
                    setIsOpen(false);
                }
            }, borderRadius: 'xl', ariaDescription: 'Dialog to display selected hotels filter options', ariaTitle: 'Selected hotels filter options', scrimColor: 'dark' },
            React.createElement(Text, { p: 3, textStyle: 'paragraphBold' }, "You have selected below options:"),
            React.createElement(Box, { p: 3 },
                Object.keys(selectedAmenities).map(function (key, i) {
                    var isSelected = Boolean(selectedAmenities === null || selectedAmenities === void 0 ? void 0 : selectedAmenities[key]);
                    var name = "chip-".concat(key, "-").concat(i);
                    return (React.createElement(FilterChip, { key: name, name: name, m: 1, selected: isSelected, label: "".concat((amenitiesMap === null || amenitiesMap === void 0 ? void 0 : amenitiesMap[key]) || key), showActionIcon: isSelected, onClick: function () {
                            var _a;
                            setSelectedAmenities(__assign(__assign({}, selectedAmenities), (_a = {}, _a[key] = !isSelected, _a)));
                        } }));
                }),
                React.createElement(Box, null,
                    React.createElement("br", null),
                    React.createElement(Button, { onClick: function () {
                            var promptMessage = {
                                role: 'user',
                                content: "Please remove the these filters: ".concat(Object.keys(selectedAmenities).reduce(function (res, key) {
                                    if (!(selectedAmenities === null || selectedAmenities === void 0 ? void 0 : selectedAmenities[key])) {
                                        res += ", ".concat((amenitiesMap === null || amenitiesMap === void 0 ? void 0 : amenitiesMap[key]) || key);
                                    }
                                    return res;
                                }, '')),
                            };
                            localCache.setLocalPrompts(promptMessage);
                            // new message in Dialog
                            var displayMessage = __assign(__assign({}, promptMessage), { date: new Date() });
                            // display new message, in dialog
                            setChatMessages(__spreadArray(__spreadArray([], localCache.getLocalMessages(), true), [displayMessage], false));
                            localCache.setLocalMessages(displayMessage);
                            submitMessages(promptMessage);
                            setIsOpen(false);
                        } }, "Apply"))))));
};
export var SelectedFiltersOptionsMessage = function (props) { return (React.createElement(ChatMessage, { mb: '40px', ml: '', variation: 'initial', Icon: TravelBotLogoImage, message: React.createElement(SelectedFiltersOptions, __assign({}, props)) })); };
//# sourceMappingURL=SelectedFiltersOptions.js.map